import React from 'react';

const Price = ({salePrice, originalPrice}) => {
    if (!originalPrice || originalPrice === 0) {
        return (
            <div className='book__price'>
                Unavailable
            </div>
        )
    };
  return (
    <div className="book__price">
        {salePrice && salePrice !== 0 ? (
            <>
                <span className="book__price--normal">
                    ${originalPrice.toFixed(2)}
                </span> 
                ${salePrice.toFixed(2)}
            </>

            ) : <>${originalPrice.toFixed(2)}</>
        }
        
    </div>
  );
};

export default Price;